<template>
  <div class="container">

    <div class="qipao" id="qipao" v-if="show_wx">
      <p>
        请点击右上角
        <br />选择“在
        <span v-text="browser"></span>打开”
      </p>
    </div>
    <!-- <div id="wx" v-show="show_wx">
      <img :src="wx" id="wx_img" />
    </div>
    <div>
      <img :src="btn" id="btn_img" @click="download()" />
    </div>-->
    <el-image
      style="width: 120px; height: 120px; margin-top: 130px;"
      :src="require('@/assets/app_icon.png')"
      fit="contain"
    />
    <span class="title">撼高组</span>
    <div class="divider" />
    <!-- <span class="desc">版本号：V1.0.5</span>
    <span class="desc">更新时间：2020-06-23 10:00:00</span> -->
    <router-link :to="{ name: 'Download'}">
      <el-button style="margin-top: 14px;" type="primary" round @click="download">立即下载APP</el-button>
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: "android",
      show_wx: false,
      browser: "浏览器",
      btn: "https://img01.wconceptimg.cn/media/huodong/2020/05/05_15/timg.jpeg",
      wx: "https://img01.wconceptimg.cn/media/huodong/course/logo.png"
    };
  },

  created() {
    let ua = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(ua)) {
      this.type = "ios";
      this.browser = "Safari中";
    } else if (/android/.test(ua)) {
      this.type = "android";
    }

    if (isWeixinBrowser() || isWeiboBrowser()) {
      this.show_wx = true;
    }

    function isWeixinBrowser() {
      return /micromessenger/.test(ua) ? true : false;
    }

    function isWeiboBrowser() {
      return /weibo/.test(ua) ? true : false;
    }
  },

  methods: {
    download() {
      const that = this;
      if (that.type == "android") {
        window.location.href = "https://dl.veim.cn/download/hgz-app-latest.apk";
      } else {
        // window.location.href = "IOS下载地址";
        alert("期待上线");
      }
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
}

.title {
  color: #242424;
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
}
.divider {
  width: 240px;
  height: 2px;
  background-color: #f3f3f3;
  margin-bottom: 8px;
}
.desc {
  color: #736f6f;
  font-size: 14px;
  padding: 2px;
}
.qipao {
  padding: 10px;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 20px;
  right: 10px;
  z-index: 1;
  border-radius: 8px;
}
.qipao {
  box-shadow: 0px 0px 45px #fff;
}
.qipao:before {
  content: " ";
  position: absolute;
  top: -19px;
  right: 12px;
  border: 8px solid transparent;
  border-bottom-width: 11px;
  border-bottom-color: rgba(0, 0, 0, 0.8);
}
.qipao p {
  font-size: 16px;
  color: #fff;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/Download.vue